import { Comparison, SchoolComparison } from "@interfaces/school"
import clsx from "clsx"
import { useState } from "react"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"
import { ProgramHeading } from "../general/ProgramHeading"

interface Props {
  comparison: SchoolComparison[]
}

export const ProgramComparison = ({ comparison }: Props) => {
  const [open, setOpen] = useState(true)

  const BASIC_CELL = clsx("sm:p-6 sm:w-1/3 text-left border border-new-grey", "w-1/2 p-4")
  const HEADER_CELL = clsx("sm:text-2xl", "sm-only:py-6")
  const LEFT_CELL = clsx("sm:text-lg font-semibold sm:w-[200px]")
  const BLUE_CELL = "bg-[#EBEFFC]"
  const RED_CELL = "!bg-[#FEF6F8]"

  function comparisonValue(data: Comparison) {
    switch (true) {
      case data.title === "TRUE" && data.type === "ICON":
        return <FaCheckCircle className="text-green sm:text-2xl" />
      case data.title === "FALSE" && data.type === "ICON":
        return <FaTimesCircle className="text-red sm:text-2xl" />

      default:
        return data.title
    }
  }

  const ComparisonRow = ({ data }: { data: SchoolComparison }) => {
    return (
      <>
        {/* Mobile only */}
        <tr className="w-full sm:hidden">
          <td className={clsx(BASIC_CELL, LEFT_CELL, "!w-full")} colSpan={2}>
            {data.comparison_name}
          </td>
        </tr>
        <tr className={clsx("w-full", !open && "hidden")}>
          {/* Web Only */}
          <td scope="row" className={clsx(BASIC_CELL, LEFT_CELL, "sm-only:hidden")}>
            {data.comparison_name}
          </td>
          <td className={clsx(BASIC_CELL, BLUE_CELL, !open && "!p-0 h-0")}>
            {comparisonValue(data.comparison_for_harisenin)}
          </td>
          <td className={clsx(BASIC_CELL, RED_CELL, !open && "!p-0 h-0")}>
            {comparisonValue(data.comparison_for_other)}
          </td>
        </tr>
      </>
    )
  }

  return (
    <section className={clsx("relative sm:mb-15", "mb-8")} id="comparison1">
      <ProgramHeading
        id="comparison"
        title="Perbandingan"
        subTitle="Apa yang Membuat Harisenin.com Beda dari yang Lain?"
      />

      <table className="w-full border border-new-grey">
        <thead>
          <tr>
            {/* Web Only */}
            <th className={clsx(BASIC_CELL, LEFT_CELL, HEADER_CELL, "sm-only:hidden")}>
              Fasilitas
            </th>
            <th className={clsx(BASIC_CELL, HEADER_CELL, BLUE_CELL, "text-base")}>Harisenin.com</th>
            <th className={clsx(BASIC_CELL, HEADER_CELL, RED_CELL, "text-base")}>Program lain</th>
          </tr>
        </thead>
        <tbody>
          <tr className="sm:hidden w-full bg-[#f9f9f9]">
            <td />
            <td
              className="p-4 text-blue font-bold text-sm w-full "
              style={{
                background:
                  "linear-gradient(0deg, rgba(58, 53, 65, 0.03) 0%, rgba(58, 53, 65, 0.03) 100%), #FFF;",
              }}
            >
              <button onClick={() => setOpen(!open)} className="underline">
                {open ? "Tutup" : "Buka"} Semua Tabel
              </button>
            </td>
          </tr>
          {comparison
            // .sort((a, b) => a.comparison_position - b.comparison_position)
            .map((value, index) => (
              <ComparisonRow data={value} key={index} />
            ))}
        </tbody>
      </table>
    </section>
  )
}
